// Only ever put http(s) URLs into href/src/window.open. Anything else that
// arrives from the API or a third party (javascript:, data:, vbscript:) is
// dropped, so a stored value can never become a click-to-run script.

const SAFE = /^https?:\/\//i;

export function safeHref(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  const trimmed = url.trim();
  return SAFE.test(trimmed) ? trimmed : undefined;
}

export function openSafe(url: string | null | undefined): void {
  const href = safeHref(url);
  if (href) window.open(href, "_blank", "noopener,noreferrer");
}
